import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/utils';

const badgeVariants = cva(
  'inline-flex items-center text-additional-white rounded-full border font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary-600',
        secondary: 'bg-blue-100 text-blue-600 border-none',
        outline: 'text-foreground text-primary-600',
        destructive: 'bg-error-600 text-additional-white',
        success: 'bg-green-100/30 text-green-600 border-none',
        muted: 'bg-grayScale-300/30 text-grayScale-900 border-none',
        warning: 'bg-warning-200/30 text-goldenSand border-none',
      },
      size: {
        sm: 'px-1.5 py-px text-[8px]',
        md: 'px-4 py-1 text-[12px]',
        lg: 'px-1.5 py-2 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
